// extracted by mini-css-extract-plugin
export default {"wrapper":"otp-input_wrapper__isgqL","error":"otp-input_error__giRlz"};